import React from "react";
import api from "../../../api/Api";
import Grid from "@material-ui/core/Grid";
import Business from "@material-ui/icons/Group";
import ReactTable from "react-table";
import matchSorter from "match-sorter";
import {NavLink} from "react-router-dom";
import Icon from "@material-ui/core/Icon";
import Loader from "../../../components/Loader";
import "react-table/react-table.css";
import Button from "components/CustomButtons/Button.jsx";

import FormControl from "@material-ui/core/FormControl";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import {
    mappingUI, dashboardRouter, getDateConverter, isClinicMasterOrClinic,
    clinicmaster_id,
    getClinicUserId
} from '../../../util/globalHelper';
import Permissions from '../../../util/globalPermissions';
import InputLabel from "@material-ui/core/InputLabel";
import Tooltip from "@material-ui/core/Tooltip";

class UserRolesList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            clinicMasterList: null,
            clinicmaster_id: "",
        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
    }

    componentDidMount() {
        this.CallReadApi()
    }

    RouteToAdd() {

    }

    render() {
        const {classes} = this.props;
        const {data, clinicMasterList} = this.state;
        if (this.state.clinicMasterList && this.state.data)
            return (<div>
                <Grid container>
                    {mappingUI(Permissions.AddUser) ? <GridItem xs={12} sm={12} md={2}>
                        <NavLink block color="success"
                                 to={dashboardRouter(`/user/role/add`)}
                                 style={{padding: 8, marginLeft: '10%'}}>
                            <Button block color="warning">
                                <Icon>add</Icon>
                                <span style={{paddingLeft: 10}}>ADD NEW</span>
                            </Button>
                        </NavLink>
                        <br/>
                    </GridItem> : null}
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="info" icon>
                                <CardIcon color="info">
                                    <GridContainer>
                                        <GridItem>
                                            <Business/>
                                        </GridItem>
                                        <GridItem style={{marginTop: -2}}>
                                            <h4>Users</h4>
                                        </GridItem>
                                    </GridContainer>
                                </CardIcon>
                                <GridContainer>

                                    <GridItem xs={12} sm={6} md={6}>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>

                                        {isClinicMasterOrClinic() === "" ? <FormControl
                                            fullWidth>
                                            <InputLabel
                                                htmlFor="clinicmaster_id">
                                                Clinic Master
                                            </InputLabel>
                                            <Select
                                                value={this.state.clinicmaster_id}
                                                onChange={this.onChangeSelect}
                                                inputProps={{
                                                    name: "clinicmaster_id",
                                                    id: "clinicmaster_id"
                                                }}
                                            >
                                                <MenuItem disabled>
                                                    Select Clinic
                                                </MenuItem>
                                                {clinicMasterList.map((x) => {
                                                    return <MenuItem key={Math.random()}
                                                                     style={{height: "1.8em"}}
                                                                     value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                })}
                                            </Select>
                                        </FormControl> : null}
                                    </GridItem>
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                {data ? <ReactTable
                                    data={data}
                                    filterable
                                    defaultFilterMethod={(filter, row) =>
                                        String(row[filter._id]) === filter.value}
                                    columns={[
                                        {
                                            columns: [
                                                {
                                                    Header: "Username",
                                                    accessor: "user_id.username",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["user_id.username"]}),
                                                    filterAll: true
                                                },
                                                {
                                                    Header: "Name",
                                                    accessor: "user_id.name",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["user_id.name"]}),
                                                    filterAll: true
                                                },

                                                {
                                                    Header: "Organization",
                                                    accessor: "clinic_master_id.name",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["clinic_master_id.name"]}),
                                                    filterAll: true
                                                },
                                                {
                                                    Header: "Role",
                                                    id: "role",
                                                    accessor: "clinic_permission_id.role_name",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["clinic_permission_id.role_name"]}),
                                                    filterAll: true
                                                },
                                                {
                                                    Header: "Contact",
                                                    accessor: "user_id.contact",
                                                    filterMethod: (filter, rows) =>
                                                        matchSorter(rows, filter.value, {keys: ["user_id.contact"]}),
                                                    filterable: true,
                                                    sortable: true
                                                },
                                                {
                                                    Header: "Status",
                                                    id: "status",
                                                    accessor: "user_id.status",
                                                    Cell: ({index}) =>
                                                        (<div>
                                                                <p>{data[index].user_id.status}</p>
                                                            </div>
                                                        ),
                                                    filterable: false,
                                                    sortable: false
                                                },

                                                {
                                                    Header: "Actions",
                                                    id: 'request_state',
                                                    filterable: false,
                                                    sortable: false,
                                                    Cell: ({index}) =>
                                                        (<div style={{textAlign: "center"}}>
                                                                {mappingUI(Permissions.ViewUsers) ?
                                                                    <NavLink color="info"
                                                                             to={dashboardRouter(`/user/role/clinicmaster/${data[index].clinic_master_id ? data[index].clinic_master_id._id : null}/${data[index].user_id._id}`)}
                                                                             style={{padding: 8, marginLeft: '10%'}}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="View"
                                                                            placement="bottom">
                                                                            <Button type="button" color="info"
                                                                                    style={{
                                                                                        padding: 8,
                                                                                        marginLeft: '10%'
                                                                                    }}>
                                                                                <Icon style={{fontSize: 20}}>info</Icon>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </NavLink> : null}
                                                            </div>
                                                        )
                                                }
                                            ]
                                        }
                                    ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                /> : null}

                            </CardBody>
                        </Card>
                    </GridItem>
                </Grid>
            </div>)
        else
            return (
                <div>
                    <Loader/>
                </div>
            )
    }

    CallReadApi = () => {
        api.listClinicMaster().then(json => {
            if (!json.data.isError) {
                this.setState({clinicMasterList: json.data.data})
            }
        });
        api.getUsersList().then(json => {
            if (!json.data.isError) {
                this.setState({data: json.data})
            }
        });
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state, () => {
            var postBody = {
                "clinic_master_id": this.state.clinicmaster_id,
            };
            this.setState({data: null})
            api.getUsersList(postBody).then(json => {
                if (!json.data.isError) {
                    this.setState({data: json.data})
                }
            });
        });


    }
}

export default UserRolesList



// WEBPACK FOOTER //
// ./src/views/Roles/User/UserRolesList.jsx